import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
/* eslint-disable react/no-unused-prop-types */

import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import axios from 'axios';
import { DASHBOARD_URL, INITIAL_MODAL_TIMER } from './PublishBanner.constants';
import { SubscriptionsContextProvider } from './PublishBanner.context';
import { getPublishModalComponentFromCollectionMethod, getPublishModalPropsFromCollectionMethod, getRequestEditModalComponentFromCollectionMethod, getRequestEditModalPropsFromCollectionMethod } from './PublishBanner.utils';
import InitialModal from './components/InitialModal';
import OutboundLink from '../../atoms/OutboundLink/OutboundLink';
import Script from '../../components/Script';
import { STRATEGY_IDLE } from '../../components/Script/Script.constants';
import { LogRocket } from '../../services/analytics';
import { BusinessPropType } from '../../services/proptypes';
import { getBusinessTypePath } from '../../utils/api';
import './style/PublishBanner.css';
var PublishBanner = /*#__PURE__*/function (_React$Component) {
  _inherits(PublishBanner, _React$Component);
  var _super = _createSuper(PublishBanner);
  function PublishBanner(props) {
    var _this;
    _classCallCheck(this, PublishBanner);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handlePublishClose", function () {
      var checkedOut = _this.state.checkedOut;
      _this.setState({
        showPublishModal: false
      }, function () {
        if (checkedOut) {
          _this.setState({
            needsPayment: false
          });
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onSelectSubscription", function (selectedSubscription) {
      _this.setState({
        selectedSubscription: selectedSubscription
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onSelectPeriod", function (selectedPeriod) {
      _this.setState({
        selectedPeriod: selectedPeriod
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleRequestOpen", function () {
      _this.setState({
        showRequestEditModal: true,
        showInitialModal: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handlePublishOpen", function () {
      _this.setState({
        showPublishModal: true,
        showInitialModal: false,
        showBanner: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleRequestClose", function () {
      _this.setState({
        showRequestEditModal: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleInitialClose", function () {
      _this.setState({
        showInitialModal: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onMinimizeClick", function () {
      _this.setState({
        showBanner: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onCartClick", function () {
      _this.setState({
        showBanner: true
      });
      _this.handlePublishOpen();
    });
    _defineProperty(_assertThisInitialized(_this), "onCheckoutCompleted", function () {
      _this.setState({
        checkedOut: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "setInitialModalTimer", function () {
      var needsPayment = _this.state.needsPayment;
      if (needsPayment) setTimeout(_this.openInitialModal, INITIAL_MODAL_TIMER);
    });
    _defineProperty(_assertThisInitialized(_this), "configureLogRocket", function () {
      var business = _this.props.business;
      var name = business.name;
      LogRocket.init();
      LogRocket.identify(name);
    });
    _defineProperty(_assertThisInitialized(_this), "openInitialModal", function () {
      _this.setState({
        showInitialModal: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "fetchSubscriptionDetails", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var url, business, businessId, businessType, _yield$axios$get, data, needsPayment, brandIdentity, subscriptionOptions, selfService;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            url = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL;
            business = _this.props.business;
            businessId = business.id, businessType = business.type;
            _context.prev = 3;
            _context.next = 6;
            return axios.get("".concat(url, "businesses/").concat(getBusinessTypePath(businessType), "/").concat(businessId, "/subscriptions/"));
          case 6:
            _yield$axios$get = _context.sent;
            data = _yield$axios$get.data;
            needsPayment = data.needs_payment, brandIdentity = data.brand_identity, subscriptionOptions = data.available_plans, selfService = data.is_self_service;
            _this.setState({
              needsPayment: needsPayment,
              brandIdentity: brandIdentity,
              subscriptionOptions: subscriptionOptions,
              selfService: selfService
            }, _this.setInitialModalTimer);
            _context.next = 15;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](3);
            LogRocket.captureError(_context.t0);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 12]]);
    })));
    _this.state = {
      showRequestEditModal: null,
      showPublishModal: null,
      showBanner: props.defaultShowBanner,
      showInitialModal: false,
      checkedOut: false,
      needsPayment: false,
      selfService: false,
      selectedSubscription: {},
      selectedPeriod: '',
      subscriptionOptions: []
    };
    return _this;
  }
  _createClass(PublishBanner, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.configureLogRocket();
              _context2.next = 3;
              return this.fetchSubscriptionDetails();
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        collectionMethod = _this$props.business.collectionMethod,
        enablePopup = _this$props.enablePopup;
      var _this$state = this.state,
        needsPayment = _this$state.needsPayment,
        brandIdentity = _this$state.brandIdentity,
        selfService = _this$state.selfService,
        showBanner = _this$state.showBanner,
        showRequestEditModal = _this$state.showRequestEditModal,
        showPublishModal = _this$state.showPublishModal,
        showInitialModal = _this$state.showInitialModal,
        subscriptionOptions = _this$state.subscriptionOptions,
        selectedSubscription = _this$state.selectedSubscription,
        selectedPeriod = _this$state.selectedPeriod;
      if (!needsPayment) return null;
      var subscriptionContextValue = {
        brandIdentity: brandIdentity,
        subscriptionOptions: subscriptionOptions,
        selectedSubscription: selectedSubscription,
        selectedPeriod: selectedPeriod,
        onSelectSubscription: this.onSelectSubscription,
        onSelectPeriod: this.onSelectPeriod
      };
      return /*#__PURE__*/React.createElement(SubscriptionsContextProvider, {
        value: subscriptionContextValue
      }, enablePopup && showInitialModal && showRequestEditModal === null && showPublishModal === null && /*#__PURE__*/React.createElement(InitialModal, {
        handlePublishOpen: this.handlePublishOpen,
        handleRequestOpen: this.handleRequestOpen,
        handleInitialClose: this.handleInitialClose,
        selfService: selfService
      }), showBanner ? /*#__PURE__*/React.createElement("div", {
        className: "payment-banner"
      }, /*#__PURE__*/React.createElement(Script, {
        strategy: STRATEGY_IDLE,
        src: "https://js.stripe.com/v3/"
      }), !selfService ? /*#__PURE__*/React.createElement(getRequestEditModalComponentFromCollectionMethod(collectionMethod), getRequestEditModalPropsFromCollectionMethod(collectionMethod, this)) : /*#__PURE__*/React.createElement(OutboundLink, {
        className: "edit-website-self-service",
        to: DASHBOARD_URL,
        label: "Edit Website"
      }), /*#__PURE__*/React.createElement(getPublishModalComponentFromCollectionMethod(collectionMethod), getPublishModalPropsFromCollectionMethod(collectionMethod, this)), /*#__PURE__*/React.createElement(Button, {
        id: "minimize-icon-button",
        "aria-label": "Close sign up banner",
        className: "minimize-icon-container",
        onClick: this.onMinimizeClick
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "close",
        className: "minimize-icon"
      }))) : /*#__PURE__*/React.createElement(Button, {
        id: "cart-icon-button",
        className: "cart-icon-container payment-publish-button",
        onClick: this.onCartClick
      }, "Sign Up"));
    }
  }]);
  return PublishBanner;
}(React.Component);
export { PublishBanner as default };
PublishBanner.defaultProps = {
  enablePopup: false,
  showRequesterInformation: false
};